import { StatusText, type StatusTone } from '../../../../components/table/StatusText';
import { ROUTING_STATUS, type RoutingStatus } from '../routingTypes';

/**
 * Where a received document stands, as a pill — for the PROFILE header, where `pending` is legal.
 *
 * **Not for an index page.** There the routing state is a STAGE column (`stage: true`), which the
 * table rule draws at tone `inactive` on every state beside the live-or-deleted status pill; amber
 * on a list of records reads as the brand's chrome. The WORD carries the meaning either way.
 */
export function RoutingStatusPill({
  status,
  label,
  isActive,
}: {
  status: RoutingStatus;
  label: string;
  isActive: boolean;
}) {
  if (!isActive) {
    return <StatusText tone="inactive">Deleted</StatusText>;
  }

  return <StatusText tone={TONE[status]}>{label}</StatusText>;
}

const TONE: Record<RoutingStatus, StatusTone> = {
  [ROUTING_STATUS.received]: 'active',
  [ROUTING_STATUS.inTransit]: 'pending',
  [ROUTING_STATUS.dispatched]: 'inactive',
};
